import { Component, Input, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { SignupPromptService } from '../../../core/services/signup-prompt.service';
import { WishlistService } from '../../../core/services/wishlist.service';
import { formatCondition, formatPriceCents } from '../../../core/utils/currency';
import type { Product } from '../../../core/models/product.model';
import { IconComponent } from '../icon/icon.component';
import { ProductImageComponent } from '../product-image/product-image.component';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [RouterLink, ProductImageComponent, IconComponent],
  templateUrl: './product-card.component.html',
})
export class ProductCardComponent {
  private readonly authService = inject(AuthService);
  private readonly wishlistService = inject(WishlistService);
  private readonly signupPromptService = inject(SignupPromptService);

  @Input({ required: true }) product!: Product;
  /** First above-the-fold card on /shop — its photo is that page's LCP. */
  @Input() priority = false;

  readonly formatPriceCents = formatPriceCents;
  readonly formatCondition = formatCondition;

  readonly isNew = computed(() => {
    const createdAt = new Date(this.product.createdAt).getTime();
    return Date.now() - createdAt < 14 * 24 * 60 * 60 * 1000;
  });

  readonly isSold = computed(() => this.product.status === 'RECENTLY_SOLD');

  isSaved(): boolean {
    return this.wishlistService.isSaved(this.product.id);
  }

  toggleSave(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.authService.isAuthenticated()) {
      this.signupPromptService.show('Create a free account to save this saddle.');
      return;
    }

    this.wishlistService.toggle(this.product.id).subscribe();
  }
}
